import { FC } from "react";

import { ReportNavigationToggleButton } from "@ryde/layout";

import {
  PanelTopRightReports,
  ReportsPanelTopSettingsStyled,
  ReportsPanelTopWrapper,
} from ".";
import { ReportNavigationDashboardButton } from "./report-navigation-dashboard.button";

export const ReportsPanelTopStatLine: FC = () => {
  return (
    <ReportsPanelTopWrapper>
      <ReportsPanelTopSettingsStyled>
        <ReportNavigationToggleButton />
        <ReportNavigationDashboardButton />
        <PanelTopRightReports />
      </ReportsPanelTopSettingsStyled>
    </ReportsPanelTopWrapper>
  );
};
